import { useContext } from 'react'
import { BuilderContext } from '../BuilderContextInstance'

export const useBuilder = () => {
  const ctx = useContext(BuilderContext)
  if (!ctx) throw new Error('useBuilder must be used inside a BuilderProvider')
  return ctx
}
